import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Trash2 } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteButton',
  props: {
    buttonText: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "delete",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.buttonText || _ctx.$t('tables.delete')), 1),
      _createVNode(_unref(Trash2), { class: "size-3" })
    ]),
    _: 1
  }))
}
}

})